var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"worker"},[_c('div',{staticClass:"item-info"},[_c('icon',{attrs:{"iconName":'loading'}}),_c('span',[_vm._v("正在處理出貨單 ("+_vm._s(_vm.process_step)+" / "+_vm._s(_vm.order_cnt)+")")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }